var Admin__AdministratorsController;

import OrganizationNavigator from 'trunks/vue/admin/compositions/organizations_sidebar/organization_navigator.js';

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import OrganizationAdministratorsContainer from 'trunks/vue/admin/components/organizations/users_organizations_container/organization_administrators.js';

export default Admin__AdministratorsController = (function() {
  class Admin__AdministratorsController extends Skylark.App.BaseController {
    index() {
      var organization_container, page;
      this._generateOrganizationSidebarView(this.getIds()[0]);
      organization_container = DomMaster.find("#js-organization-container").node;
      page = this.getVars();
      return new OrganizationAdministratorsContainer({
        el: organization_container,
        propsData: {
          organization: page.organization,
          organizationApplicationsCount: page.pending_organization_applications_count,
          organizationAdministratorsCount: page.organization_administrators_count,
          activeTab: 'administrators'
        }
      });
    }

  };

  Admin__AdministratorsController.include(GenerateMorePopover);

  Admin__AdministratorsController.include(OrganizationNavigator);

  return Admin__AdministratorsController;

}).call(this);
